export default __webpack_public_path__ + "static/media/FacebookPrivate.1af19ca2.png";